import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';
import fs from 'fs';
import b64toBlob from 'b64-to-blob';

import ContentHeader from '../common/template/contentHeader';
import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import BoxButtonFooter from '../common/button/boxButtonFooter';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import NumberFormat from 'react-number-format';

import { initForm, setModoTela, getListaGranja, getListaFornecedor, getListaAnimal, getListaItens, adicionarItem, alterarItem, removerItem, ratearPeso, ratearValor } from './compraAnimalActions';

class CompraAnimalForm extends Component {

	state = {
		filtroAnimal: '',
		listaItens: [],
		pesoRateio: 0,
		valorRateio: 0
	};

    componentWillMount() {
		this.props.getListaGranja(this.props.sessao.id_empresa);
		this.props.getListaFornecedor(this.props.sessao.id_empresa);
		if (this.props.formularioValues.id) {
			this.props.getListaAnimal(this.props.formularioValues.id_granja, this.props.sessao.id_empresa);
			this.props.getListaItens(this.props.formularioValues.id, this.props.sessao.id_empresa);
		} else {
			this.props.getListaItens(0, this.props.sessao.id_empresa);
		}
    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		let filtroAnimal = this.state.filtroAnimal ? this.state.filtroAnimal.toUpperCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : null;
		let listaAnimal = (this.props.listaAnimal || []).filter(animal => {

			if (!filtroAnimal) {
				return false;
			}

			if (this.props.listaItens.filter(item => item.id_animal == animal.id).length > 0) {
				return false;
			}

			let dadosAnimal = `${animal.numero_brinco}`;
			dadosAnimal = dadosAnimal.toUpperCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

			return dadosAnimal.indexOf(filtroAnimal) != -1;

		});

		if (this.props.listaItens && (this.state.listaItens.length != this.props.listaItens.length
				|| this.state.listaItens.filter(itemCompraAnimal => {
					let retorno = false;
					this.props.listaItens.forEach(itemCompraAnimalProps => {
						if (itemCompraAnimalProps.id == itemCompraAnimal.id && itemCompraAnimalProps.datahora_alteracao != itemCompraAnimal.datahora_alteracao) {
							retorno = true;
						}
					});
					return retorno;
				}).length > 0)) {
			this.setState({
				...this.state,
				listaItens: this.props.listaItens.map(item => item)
			});
		}

		let femeaBase = parseInt(this.props.formularioValues.quantidade_nao_identificado_femea || 0);
		let machoBase = parseInt(this.props.formularioValues.quantidade_nao_identificado_macho || 0);

		let listaFaixaIdade = [
			{ nome: '0 - 12', faixaInicial: null, faixaFinal: 12, femea: 0, macho: 0 },
			{ nome: '13 - 24', faixaInicial: 13, faixaFinal: 24, femea: 0, macho: 0 },
			{ nome: '25 - 36', faixaInicial: 25, faixaFinal: 36, femea: 0, macho: 0 },
			{ nome: '36 +', faixaInicial: 37, faixaFinal: null, femea: femeaBase, macho: machoBase }
		];
		this.state.listaItens.forEach(item => {
			listaFaixaIdade = listaFaixaIdade.map(faixaIdade => {
				if ((faixaIdade.faixaInicial == null || item.idade >= faixaIdade.faixaInicial)
					&& (faixaIdade.faixaFinal == null || item.idade <= faixaIdade.faixaFinal)) {
					if (item.id_sexo == 1) {
						return {
							...faixaIdade,
							femea: faixaIdade.femea + 1
						}
					} else {
						return {
							...faixaIdade,
							macho: faixaIdade.macho + 1
						}
					}
				}
				return faixaIdade;
			});
		});

		let pesoTotal =  0;
		let valorTotal = 0;

		let totalFemeas = 0;
		let totalMachos = 0;

        return (
			<div>
				<ContentCard>
					<Form event={this.props.handleSubmit}>
						<Row>
							<Field
								name='datahora_compra'
								component={LabelAndInputDateTime}
								label='Data e hora da Compra'
								placeholder='Informe a data e a hora'
								cols='8 4 3 2'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='id_granja'
								component={Select}
								options={this.props.listaGranja}
								label='Granja *'
								cols='12 12 8 4'
								placeholder='Selecione a Granja'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='id_fornecedor'
								component={Select}
								options={this.props.listaFornecedor}
								label='Fornecedor *'
								cols='12 12 8 4'
								placeholder='Selecione o Fornecedor'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='numero_nota'
								component={LabelAndInput}
								label='Número da Nota'
								placeholder='Número da Nota de Compra'
								cols='12 6 6 3'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='observacao'
								component={LabelAndTextarea}
								label='Observação'
								placeholder='Observação da compra'
								cols='12 12 8 6'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Grid cols='12'>
								<div className='form-group'>
									<label>Anexo</label>
									{this.props.formularioValues.anexo ? (
										<div>
											<span class="input-group-btn">
												<button type='button' class='btn btn-primary btn-flat' style={{ marginRight: 4 }}
													onClick={() => {
														let blob = b64toBlob(this.props.formularioValues.anexo.split(',')[1], this.props.formularioValues.anexo.split(',')[0]);
														window.location = URL.createObjectURL(blob);
													}}>
													<i class='fa fa-download' aria-hidden='true'></i>
												</button>
												<button type='button' class='btn btn-danger btn-flat'
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															anexo: null
														}, 'compraAnimalForm');
													}}>
													<i class='fa fa-trash' aria-hidden='true'></i>
												</button>
											</span>
										</div>
									) : (
										<Field
											name='anexo'
											type='file'
											accept=''
											component={({ input, type, meta }) => {
												const { mimeType } = this.props;
									  			return (
									  				<div>
									  					<input
									  						name={input.name}
									  						type={type}
									  						accept={mimeType}
									  						onChange={event => {
									  							event.preventDefault();
									  							let reader = new FileReader();
									  							let file = event.target.files[0];

									  							reader.onloadend = () => {
									  								input.onChange(reader.result);
																	this.props.initForm({
																		...this.props.formularioValues,
																		anexo: reader.result
																	}, 'compraAnimalForm');
									  							}

									  							reader.readAsDataURL(file);
									  						}} />
									  				</div>
									  			)
											}}
					                    />
									)}
								</div>
							</Grid>
						</Row>

						<BoxButtonFooter>
							{this.props.excluir ? (
								<Button
									text='Excluir'
									submit type={'danger'}
									icon={'fa fa-trash'} />
							) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
							)}
							<Button
								text='Voltar'
								type={'warning'}
								icon={'fa fa-chevron-left'}
								event={() => this.props.setModoTela('lista')} />
						</BoxButtonFooter>
					</Form>
				</ContentCard>

				{this.props.formularioValues.id ? (
					<ContentCard>
						<ContentCardHeader title='Itens' />
						<Row>
							<Grid cols='12 8 6'>
								<label>Animal</label>
								<div style={{ display: 'flex', flex: 2 }}>
									<div style={{ flex: 1 }}>
										<input className='form-control'
											placeholder={'Selecione o Animal'}
											value={this.state.filtroAnimal}
											onChange={(data => {
												this.setState({
													...this.state,
													filtroAnimal: data.target.value
												});
											})} />
									</div>
								</div>
								{listaAnimal.length > 0 ? (
									<div style={{ display: 'flex', overflowX: 'auto', overflowY: 'auto', maxHeight: 150 }}>
										<table className='table table-bordered table-striped dataTable'>
											<THead>
												<Tr>
													<Th>Animal</Th>
													<Th>Lote</Th>
													<Th>Sexo</Th>
													<Th>Idade</Th>
												</Tr>
											</THead>
											<TBody>
												{listaAnimal.map(animal => {
													return (
														<Tr key={animal.id}
															onClick={() => {
																this.props.adicionarItem({
																	id_compra_animal: this.props.formularioValues.id,
																	id_animal: animal.id,
																	peso: animal.peso_entrada,
																	valor: 0,
																	id_granja: this.props.formularioValues.id_granja
																});
																this.setState({
																	...this.state,
																	filtroAnimal: ''
																});
															}}>
															<Td>{animal.numero_brinco}</Td>
															<Td>{animal.numero_lote}</Td>
															<Td>{animal.nome_sexo}</Td>
															<Td>{parseInt(animal.idade_atual)}</Td>
														</Tr>
													);
												})}
											</TBody>
										</table>
									</div>
								) : null}

								<br />
							</Grid>
							<Grid cols='12'>
								<Table>
									<THead>
										<Tr>
											<Th>Lote</Th>
											<Th>Animal</Th>
											<Th>Sexo</Th>
											<Th>Idade</Th>
											<Th alignCenter>Peso</Th>
											<Th alignRight>Valor</Th>
											<Th alignCenter acoes>Ações</Th>
										</Tr>
									</THead>
									<TBody>
										{this.state.listaItens.map(item => {

											pesoTotal += parseFloat(item.peso);
											valorTotal += parseFloat(item.valor);

											return (
												<Tr key={item.id}>
													<Td>{item.numero_lote}</Td>
													<Td>{item.numero_brinco_animal}</Td>
													<Td>{item.nome_sexo}</Td>
													<Td>{item.idade}</Td>
													<Td alignRight>
														{item.alteracao ? (
															<NumberFormat
																style={{ textAlign: 'right' }}
																className='form-control'
																decimalSeparator={","} decimalScale={4} fixedDecimalScale={4}
																value={String(item.peso || '0').replace('.', ',')}
																onChange={data => {
																	let lista = this.state.listaItens.map(itemCompraAnimal => {
																		if (itemCompraAnimal.id == item.id) {
																			return {
																				...itemCompraAnimal,
																				peso: data.target.value.replace(',', '.')
																			};
																		} else {
																			return itemCompraAnimal;
																		}
																	});
																	this.setState({
																		...this.state,
																		listaItens: lista
																	});
																}} />
														) : (item.peso || '0,0000').replace('.', ',')}
													</Td>
													<Td alignRight>
														{item.alteracao ? (
															<NumberFormat
																style={{ textAlign: 'right' }}
																className='form-control'
																decimalSeparator={","} decimalScale={2} fixedDecimalScale={2}
																value={String(item.valor || '0').replace('.', ',')}
																onChange={data => {
																	let lista = this.state.listaItens.map(itemCompraAnimal => {
																		if (itemCompraAnimal.id == item.id) {
																			return {
																				...itemCompraAnimal,
																				valor: data.target.value.replace(',', '.')
																			};
																		} else {
																			return itemCompraAnimal;
																		}
																	});
																	this.setState({
																		...this.state,
																		listaItens: lista
																	});
																}} />
														) : parseFloat(item.valor || '0.00').toFixed(2).replace('.', ',')}
													</Td>
													<Td alignCenter>
														{item.alteracao ? (
															<div>
																<ButtonTable
																	type={'success'}
																	icon={'fa fa-check'}
																	event={() => {
																		this.props.alterarItem({
																			...item,
																			id_granja: this.props.formularioValues.id_granja
																		});
																		this.setState({
																			...this.state,
																			alteracao: false
																		});
																	}} />

																<ButtonTable
																	type={'danger'}
																	icon={'fa fa-times'}
																	event={() => {
																		this.setState({
																			...this.state,
																			listaItens: this.props.listaItens.map(item => item),
																			alteracao: false
																		});
																	}} />
															</div>
														) : (
															<div>
																<ButtonTable
																	type={this.state.alteracao ? 'disabled' : 'warning'}
																	icon={'fa fa-pencil'}
																	disabled={true}
																	event={() => {
																		if (!this.state.alteracao) {
																			let lista = this.state.listaItens.map(itemCompraAnimal => {
																				return {
																					...itemCompraAnimal,
																					alteracao: itemCompraAnimal.id == item.id
																				};
																			});
																			this.setState({
																				...this.state,
																				listaItens: lista,
																				alteracao: true
																			});
																		}
																	}} />

																<ButtonTable
																	type={this.state.alteracao ? 'disabled' : 'danger'}
																	icon={'fa fa-trash-o'}
																	event={() => {
																		if (!this.state.alteracao) {
																			this.props.removerItem({
																				...item,
																				id_granja: this.props.formularioValues.id_granja
																			});
																		}
																	}} />
															</div>
														)}
													</Td>
												</Tr>
											);
										})}
										<Tr>
											<Th>Total</Th>
											<Th></Th>
											<Th></Th>
											<Th></Th>
											<Th alignRight>{String(pesoTotal.toFixed(4)).replace('.', ',')}</Th>
											<Th alignRight>{String(valorTotal.toFixed(2)).replace('.', ',')}</Th>
											<Th alignCenter></Th>
										</Tr>
									</TBody>
								</Table>
							</Grid>
							<Grid cols='12'>
								<Tr style={{ height: 40, verticalAlign: 'middle' }}>
									<Td>
										<NumberFormat
											style={{ textAlign: 'left', width: 120 }}
											className='form-control'
											decimalSeparator={","} decimalScale={4} fixedDecimalScale={4}
											value={String(this.state.pesoRateio).replace('.', ',')}
											onChange={data => {
												this.setState({
													...this.state,
													pesoRateio: data.target.value.replace(',', '.')
												});
											}} />
									</Td>
									<Td>
										<Button
											text='Ratear Peso'
											type={'success'}
											icon={'fa fa-random'}
											event={() => {
												this.props.ratearPeso(this.props.sessao.id_empresa, this.props.formularioValues.id, this.props.formularioValues.id_granja, this.state.pesoRateio);
											}} />
									</Td>
								</Tr>
								<Tr style={{ height: 40, verticalAlign: 'middle' }}>
									<Td>
										<NumberFormat
											style={{ textAlign: 'left', width: 120 }}
											className='form-control'
											decimalSeparator={","} decimalScale={2} fixedDecimalScale={2}
											value={String(this.state.valorRateio).replace('.', ',')}
											onChange={data => {
												this.setState({
													...this.state,
													valorRateio: data.target.value.replace(',', '.')
												});
											}} />
									</Td>
									<Td>
										<Button
											text='Ratear Valor'
											type={'success'}
											icon={'fa fa-random'}
											event={() => {
												this.props.ratearValor(this.props.sessao.id_empresa, this.props.formularioValues.id, this.props.formularioValues.id_granja, this.state.valorRateio);
											}} />
									</Td>
								</Tr>
								<br />
							</Grid>
							<Grid cols='12 12 6'>
								<Table>
									<THead>
										<Tr>
											<Th alignCenter>Idade</Th>
											<Th alignCenter>Fêmea</Th>
											<Th alignCenter>Macho</Th>
										</Tr>
									</THead>
									<TBody>
										{listaFaixaIdade.map(faixaIdade => {

											totalFemeas += faixaIdade.femea;
											totalMachos += faixaIdade.macho;

											return (
												<Tr key={faixaIdade.nome}>
													<Td alignCenter>{faixaIdade.nome}</Td>
													<Td alignCenter>{faixaIdade.femea}</Td>
													<Td alignCenter>{faixaIdade.macho}</Td>
												</Tr>
											);
										})}
										<Tr>
											<Th alignCenter>Total</Th>
											<Th alignCenter>{totalFemeas}</Th>
											<Th alignCenter>{totalMachos}</Th>
										</Tr>
									</TBody>
								</Table>
							</Grid>
						</Row>
					</ContentCard>
				) : null}
			</div>
        )
    }


}

CompraAnimalForm = reduxForm({form: 'compraAnimalForm', destroyOnUnmount: false})(CompraAnimalForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	listaGranja: state.compraAnimal.listaGranja,
	listaFornecedor: state.compraAnimal.listaFornecedor,
	listaAnimal: state.compraAnimal.listaAnimal,
	listaItens: state.compraAnimal.listaItens,
	registro: state.compraAnimal.registro,
	formularioValues: getFormValues('compraAnimalForm')(state)
});
const mapDispatchToProps = dispatch => bindActionCreators({ initForm, setModoTela, getListaGranja, getListaFornecedor, getListaAnimal, getListaItens, adicionarItem, alterarItem, removerItem, ratearPeso, ratearValor }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CompraAnimalForm);
